import React, { Component } from 'react'
import MeImg from './woosik.jpg'

export default class AboutRight extends Component {


    render() {

        const bgStyle = {
            backgroundImage: 'url(' + MeImg + ')',
            backgroundRepeat: 'no-repeat'
        }

        return (

            <div id='AboutRight' style={bgStyle}>

                <div id='AboutName'>
                    <h1>RYU, Woosik</h1>
                    <p>Business Engineering Professional at LG CNS Co.,Ltd.</p>
                </div>

            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/about/AboutRight.js